import AudiA8 from '../../assets/collection/audi.jpg';
import nissan from '../../assets/collection/nissan.jpg';
import porsche01 from '../../assets/collection/porsche01.jpg';
import bmw01 from '../../assets/collection/bmw01.jpg';
import bmw from '../../assets/collection/bmw.jpg';
import porsche from '../../assets/collection/porsche.jpg';

export const collectionData = [
  {
    id: 1,
    title: 'Audi A8 L 2022',
    img: AudiA8,
    price: '78.90',
    miles: '40000',
    gear: 'Auto',
    seating: '4',
    fuel: 'Electric',
  },
  {
    id: 2,
    title: 'Nissan Maxima Platinum 2022',
    img: nissan,
    price: '78.90',
    miles: '40000',
    gear: 'Auto',
    seating: '4',
    fuel: 'Electric',
  },
  {
    id: 3,
    title: 'Porsche Cayenne GTS 2022',
    img: porsche01,
    price: '78.90',
    miles: '40000',
    gear: 'Auto',
    seating: '4',
    fuel: 'Electric',
  },
  {
    id: 4,
    title: 'BMW M8 Coupe 2022',
    img: bmw01,
    price: '79.90',
    miles: '40000',
    gear: 'Auto',
    seating: '4',
    fuel: 'Electric',
  },
  {
    id: 5,
    title: 'BMW X7 M50i 2022',
    img: bmw,
    price: '78.90',
    miles: '40000',
    gear: 'Auto',
    seating: '4',
    fuel: 'Electric',
  },
  {
    id: 6,
    title: 'Porsche Cayenne 2022',
    img: porsche,
    price: '99.90',
    miles: '40000',
    gear: 'Auto',
    seating: '4',
    fuel: 'Electric',
  },
];
